import crownBronze from "assets/images/crownBronze.svg"
import crownGold from "assets/images/crownGold.svg"
import crownSilver from "assets/images/crownSilver.svg"
import { Card, Icon } from "materia"
import type { PropsWithChildren, ReactNode } from "react"
import { modifiers } from "ui-tools"
import { FiestaLink, type FiestaLinkProps } from "utility-components"
import { Avatar } from "../../../components/Avatar"
import s from "./LeaderboardViewCompact.module.scss"

export const LeaderboardViewCompact = ({ children }: PropsWithChildren) => (
  <div className={s.leaderboardViewCompact}>{children}</div>
)

type ScopeSelectProps = {
  value: string
  children: ReactNode
  onChange: (value: string) => void
}
const ScopeSelect = ({ children, value, onChange }: ScopeSelectProps) => (
  <select
    className={s.scopeSelect}
    value={value}
    onChange={(value) => onChange(value.target.value)}
  >
    {children}
  </select>
)

type ScopeProps = {
  value: string
  children: ReactNode
}
const Scope = ({ value, children }: ScopeProps) => (
  <option value={value}>{children}</option>
)

const Leaderboard = ({ children }: PropsWithChildren) => (
  <Card>
    <ul className={s.leaderboard}>{children}</ul>
  </Card>
)

const Header = ({
  title,
  link,
  linkText,
}: {
  title: string
  link: FiestaLinkProps
  linkText: string
}) => {
  return (
    <div className={s.header}>
      <h2 className={s.header__title}>{title}</h2>
      <FiestaLink className={s.header__seeMore} {...link}>
        <span>{linkText}</span>
        <Icon icon="Chevron" size="small" className={s.header__chevron} />
      </FiestaLink>
    </div>
  )
}

const Podium = ({ children }: PropsWithChildren) => (
  <ul className={s.podium}>{children}</ul>
)

type EntryPodiumProps = {
  rank: number
  avatar: string
  avatarTitle: string
  name: string
  score: string
  isFirst: boolean
}
const EntryPodium = ({
  rank,
  avatar,
  avatarTitle,
  name,
  score,
  isFirst,
}: EntryPodiumProps) => (
  <li className={modifiers(s, "entryPodium", { isFirst })}>
    <img className={s.entryPodium__crown} src={getCrownIcon(rank)} alt="" />
    <div className={s.entryPodium__rankWrapper}>
      <div className={s.entryPodium__rank}>{rank}</div>
      <Avatar
        className={s["entryPodium__avatar--outerGlow"]}
        alt={avatarTitle}
        image={avatar}
        size="large"
      />
    </div>
    <div className={s.entryPodium__name}>{name}</div>
    <div className={s.entryPodium__score}>{score}</div>
  </li>
)

type EntryProps = {
  rank: number
  avatar: string
  avatarTitle: string
  name: string
  score: string
  isMe: boolean
}
const Entry = ({
  rank,
  avatar,
  avatarTitle,
  name,
  score,
  isMe = false,
}: EntryProps) => (
  <li className={modifiers(s, "entry", { isMe })}>
    <div className={s.entry__rank}>{rank}</div>
    <Avatar size="medium" image={avatar} alt={avatarTitle} />
    <div className={s.entry__name}>{name}</div>
    <div className={s.entry__score}>{score}</div>
  </li>
)

const Separator = () => <div className={s.separator} />

const Skeleton = () => (
  <Card>
    <div className={s.skeleton} />
  </Card>
)

LeaderboardViewCompact.ScopeSelect = ScopeSelect
LeaderboardViewCompact.Scope = Scope
LeaderboardViewCompact.Leaderboard = Leaderboard
LeaderboardViewCompact.Header = Header
LeaderboardViewCompact.Podium = Podium
LeaderboardViewCompact.EntryPodium = EntryPodium
LeaderboardViewCompact.Entry = Entry
LeaderboardViewCompact.Separator = Separator
LeaderboardViewCompact.Skeleton = Skeleton

const getCrownIcon = (rank: number) => {
  if (rank === 1) return crownGold
  if (rank === 2) return crownSilver
  if (rank === 3) return crownBronze
}
